import {
  useCallback, useEffect, useRef, useState,
} from 'react';

const RESEND_CODE_TOTAL_MINUTES = 5;
const RESEND_CODE_TOTAL_SECONDS = RESEND_CODE_TOTAL_MINUTES * 60;

const useResendCodeTimer = () => {
  const [remainingSeconds, setRemainingSeconds] = useState(0);
  const timerRef = useRef(null);

  const startTimer = useCallback(() => {
    if (timerRef.current) {
      return;
    }

    setRemainingSeconds(RESEND_CODE_TOTAL_SECONDS);

    timerRef.current = setInterval(() => {
      setRemainingSeconds((prev) => {
        if (prev <= 1) {
          clearInterval(timerRef.current);
          timerRef.current = null;
          return 0;
        }

        return prev - 1;
      });
    }, 1000);
  }, []);

  useEffect(() => () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
  }, []);

  return {
    remainingSeconds,
    startTimer,
  };
};

export { useResendCodeTimer };
